import cardQuestionMark from "../../assets/image/cardQuestionMark.svg";
import rightArrow from "../../assets/image/rightArrow.svg";
import { TUIChatService } from "@tencentcloud/chat-uikit-engine";
import { useTUIChatActionContext } from "@tencentcloud/chat-uikit-react";
import "./BotCard.scss";
interface IBotCardProps {
  data: any;
}

export function BotCard(props: IBotCardProps) {
  
  const { setFirstSendMessage } = useTUIChatActionContext('BotCard');
  const { data } = props;
  const handleSendMessage = (text: string) => {
    const options: any = {
      payload: {
        text,
      },
    };
    TUIChatService.sendTextMessage(options).then((res: any) => {
      const { message } = res.data;
      setFirstSendMessage && setFirstSendMessage(message);
    });
  };

  return (
    <div className="custom-card">
      <div className="custom-card-title">
        <img className="custom-card-title-img" src={cardQuestionMark} alt="" />
        <span>{data.data.title || data.data.content }</span>
      </div>
      <ul className="custom-card-list">
        {data.data.items.map((item: any, index: any) => (
          <li
            className="custom-card-item"
            key={index}
            onClick={() => {
              handleSendMessage(item?.content);
            }}
          >
            <span>{item?.content}</span>
            <img className="custom-card-item-img" src={rightArrow} alt="" />
          </li>
        ))}
      </ul>
    </div>
  );
}
